import { useCallback, useRef, useState } from 'react';

export const usePaymentSubmitGuard = () => {
  const isActiveRef = useRef(false);
  const [isPaymentFlowActive, setIsPaymentFlowActive] = useState(false);

  const beginPaymentFlow = useCallback((): boolean => {
    if (isActiveRef.current) return false;
    isActiveRef.current = true;
    setIsPaymentFlowActive(true);
    return true;
  }, []);

  const endPaymentFlow = useCallback(() => {
    isActiveRef.current = false;
    setIsPaymentFlowActive(false);
  }, []);

  return { isPaymentFlowActive, beginPaymentFlow, endPaymentFlow };
};
